export { default } from './RootRef';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/RootRef/index.js
// module id = 846
// module chunks = 2